import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-8',
  templateUrl: './8.component.html',
  styleUrls: ['./8.component.scss'],
})
export class VbList8Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
